module.exports = __webpack_public_path__ + "img/largeloader_driving.018987b4.svg";